import { render, staticRenderFns } from "./ExtraServiceTable.vue?vue&type=template&id=11fbcea6&scoped=true"
import script from "./ExtraServiceTable.vue?vue&type=script&lang=ts"
export * from "./ExtraServiceTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fbcea6",
  null
  
)

export default component.exports